const ROOT = 'CHECKLISTS';

const actionTypes = {
  LOAD_CHECKLISTS: `${ROOT}_LOAD_CHECKLISTS`,
  LOAD_CHECKLISTS_SUCCESS: `${ROOT}_LOAD_CHECKLISTS_SUCCESS`,
  LOAD_CHECKLISTS_ERROR: `${ROOT}_LOAD_CHECKLISTS_ERROR`,
  CREATE_CHECKLIST_REQUEST: `${ROOT}_CREATE_CHECKLIST_REQUEST`,
  CREATE_CHECKLIST_SUCCESS: `${ROOT}_CREATE_CHECKLIST_SUCCESS`,
  CREATE_CHECKLIST_ERROR: `${ROOT}_CREATE_CHECKLIST_ERROR`,
  UPDATE_CHECKLIST_REQUEST: `${ROOT}_UPDATE_CHECKLIST_REQUEST`,
  UPDATE_CHECKLIST_SUCCESS: `${ROOT}_UPDATE_CHECKLIST_SUCCESS`,
  UPDATE_CHECKLIST_ERROR: `${ROOT}_UPDATE_CHECKLIST_ERROR`,
  LOAD_CHECKLIST_REQUEST: `${ROOT}_LOAD_CHECKLIST_REQUEST`,
  LOAD_CHECKLIST_SUCCESS: `${ROOT}_LOAD_CHECKLIST_SUCCESS`,
  LOAD_CHECKLIST_ERROR: `${ROOT}_LOAD_CHECKLIST_ERROR`,
  LOAD_FORM_DATA_REQUEST: `${ROOT}_LOAD_FORM_DATA_REQUEST`,
  LOAD_FORM_DATA_SUCCESS: `${ROOT}_LOAD_FORM_DATA_SUCCESS`,
  LOAD_FORM_DATA_ERROR: `${ROOT}_LOAD_FORM_DATA_ERROR`,
  LOAD_POSITIONS_REQUEST: `${ROOT}_LOAD_POSITIONS_REQUEST`,
  LOAD_POSITIONS_SUCCESS: `${ROOT}_LOAD_POSITIONS_SUCCESS`,
  LOAD_POSITIONS_ERROR: `${ROOT}_LOAD_POSITIONS_ERROR`,
  DELETE_CHECKLIST: `${ROOT}_DELETE_CHECKLIST`,
  DELETE_CHECKLIST_SUCCESS: `${ROOT}_DELETE_CHECKLIST_SUCCESS`,
  DELETE_CHECKLIST_ERROR: `${ROOT}_DELETE_CHECKLIST_ERROR`,
  LOAD_UNITS_REQUEST: `${ROOT}_LOAD_UNITS_REQUEST`,
  LOAD_UNITS_SUCCESS: `${ROOT}_LOAD_UNITS_SUCCESS`,
  LOAD_UNITS_ERROR: `${ROOT}_LOAD_UNITS_ERROR`,
  VALIDATE_UNITS_REQUEST: `${ROOT}_VALIDATE_UNITS_REQUEST`,
  VALIDATE_UNITS_SUCCESS: `${ROOT}_VALIDATE_UNITS_SUCCESS`,
} as const;

export default actionTypes;
